import { ChartLine, Star } from 'assets/icons';
import classNames from 'classnames';
import { TABS } from 'constants/tabs';

function TabList({ handleTabClick, currentTabKey }) {
  return (
    <div className="flex justify-center">
      {Object.keys(TABS).map((key) => {
        const tab = TABS[key];
        const isActive = currentTabKey === tab.key;
        return (
          <div
            key={`tab_${key}`}
            className={classNames(
              'font-normal text-lg  px-4  border-b-4 rounded flex items-center mt-4 mb-2',
              {
                'text-gray border-opacity-0': !isActive,
                'text-blue border-blue': isActive,
              }
            )}
            onClick={() => handleTabClick(tab)}
          >
            {tab.key === TABS.ALL_STOCK.key && <ChartLine className="mx-1" />}
            {tab.key === TABS.STRATEGY.key && <Star className="mx-1" />}
            {tab.name}
          </div>
        );
      })}
    </div>
  );
}

export default TabList;
